import styled from 'styled-components';

export const SpinnerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6b7280;
`;
